var _g, _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 129,
    viewBox: "0 0 124 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_143_6023)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.0044,
    y: 97.0356,
    width: 67.1559,
    height: 6.64267,
    fill: "#1B3554"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.5459,
    y: 40.5728,
    width: 67.1559,
    height: 43.7309,
    fill: "#E0E5EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5459 40.5728V106.999H17.7144V66.8316L28.5459 40.5728Z",
    fill: "#A0AAB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7017 40.5728V106.446H105.992V66.8316L95.7017 40.5728Z",
    fill: "#A0AAB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2617 88.6609H52.3075C50.6832 88.6609 47.2917 88.6609 47.2917 88.6609H27.314C27.314 87.4533 27.314 80.9156 27.314 80.9156L27.314 76.6908C27.3139 78.8032 27.314 71.287 27.314 70.0794V16.2106C27.314 15.003 28.6308 14.0239 30.2552 14.0239H93.2617C94.886 14.0239 96.2029 15.003 96.2029 16.2106V86.4743C96.2029 87.6819 94.886 88.6609 93.2617 88.6609Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 23.53,
    height: 1.58094,
    rx: 0.790472,
    transform: "matrix(1 -3.45935e-08 -3.50456e-06 1 52.8979 44.2856)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 15.94,
    height: 1.58094,
    rx: 0.790472,
    transform: "matrix(1 -3.45935e-08 -3.50456e-06 1 52.8145 47.6616)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 8.26666,
    height: 8.44947,
    rx: 2,
    transform: "matrix(1 0 -3.47144e-06 1 42.4695 42.6963)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 23.53,
    height: 1.58094,
    rx: 0.790472,
    transform: "matrix(1 -3.45935e-08 -3.50456e-06 1 52.8979 29.6958)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 15.94,
    height: 1.58094,
    rx: 0.790472,
    transform: "matrix(1 -3.45935e-08 -3.50456e-06 1 52.8145 33.0718)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 8.26666,
    height: 8.44947,
    rx: 2,
    transform: "matrix(1 0 -3.47144e-06 1 42.4695 28.1064)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 23.53,
    height: 1.58094,
    rx: 0.790472,
    transform: "matrix(1 -3.45935e-08 -3.50456e-06 1 52.8979 58.877)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 15.94,
    height: 1.58094,
    rx: 0.790472,
    transform: "matrix(1 -3.45935e-08 -3.50456e-06 1 52.8145 62.2529)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 8.26666,
    height: 8.44947,
    rx: 2,
    transform: "matrix(1 0 -3.47144e-06 1 42.4695 57.2876)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7144 66.5898H37.0282C38.5238 66.5898 39.7362 67.8022 39.7362 69.2978C39.7362 73.0367 42.7672 76.0677 46.5061 76.0677H60.6287H74.469C78.2079 76.0677 81.2389 73.0367 81.2389 69.2978C81.2389 67.8022 82.4513 66.5898 83.9469 66.5898H105.992V105.152C105.992 108.007 103.678 110.321 100.823 110.321H22.8834C20.0286 110.321 17.7144 108.007 17.7144 105.152V66.5898Z",
    fill: "#DAE2EC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_143_6023)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.75,
    cx: 99.5846,
    cy: 88.8333,
    rx: 15.1556,
    ry: 15.5,
    transform: "rotate(-176.081 99.5846 88.8333)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.073 79.6818L100.89 92.5702L97.8119 92.3593L98.263 79.4207L102.073 79.6818ZM97.0219 96.003C97.0605 95.4395 97.272 94.9805 97.6566 94.626C98.0518 94.262 98.5731 94.1021 99.2206 94.1465C99.858 94.1901 100.348 94.4193 100.69 94.8338C101.032 95.2382 101.184 95.7221 101.146 96.2855C101.108 96.8285 100.892 97.2821 100.497 97.6461C100.102 97.9999 99.5864 98.155 98.9489 98.1113C98.3015 98.067 97.8065 97.8426 97.4639 97.4383C97.132 97.0244 96.9847 96.546 97.0219 96.003Z",
    fill: "#B4BDC6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_143_6023",
    x: 2.99987,
    y: 72.0311,
    width: 117.165,
    height: 56.6516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5023,
    result: "effect1_foregroundBlur_143_6023"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_143_6023",
    x: 84.4268,
    y: 73.3345,
    width: 39.3157,
    height: 44.998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_143_6023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_143_6023",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/Empty.fb6a9f5b81ed52d438fd7886322adc09.svg";
export { ForwardRef as ReactComponent };